import { FunctionComponent } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

type Props = {
    user?: any | null;
}

export const UserDetails: FunctionComponent<Props> = ({ user }) => {
    if (!user) {
        return <p>User details were not able to be obtained</p>
    }

    return (
        <Form className="mb-3">
            <Form.Group as={Row} className="mb-1" controlId="forename">
                <Form.Label column xs="2">
                    <strong>Forename</strong>
                </Form.Label>
                <Col xs="10">
                    <Form.Control plaintext readOnly defaultValue={user.forename} />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-1" controlId="surname">
                <Form.Label column xs="2">
                    <strong>Surname</strong>
                </Form.Label>
                <Col xs="10">
                    <Form.Control plaintext readOnly defaultValue={user.surname} />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-1" controlId="email">
                <Form.Label column xs="2">
                    <strong>Email</strong>
                </Form.Label>
                <Col xs="10">
                    <Form.Control plaintext readOnly defaultValue={user.email} />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-1" controlId="partnerId">
                <Form.Label column xs="2">
                    <strong>Partner ID</strong>
                </Form.Label>
                <Col xs="10">
                    <Form.Control plaintext readOnly defaultValue={user.partnerId} />
                </Col>
            </Form.Group>
        </Form>
    );
}
